import { createAsyncThunk } from '@reduxjs/toolkit';
import { BundleCake } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import {
  CreatePatchBundleCake,
  FindBundleCake,
  GetBundleCake,
} from './interface';

export const findBundleCake = createAsyncThunk(
  'bundleCake/findBundleCake',
  async (values: FindBundleCake, { rejectWithValue }) => {
    try {
      const response = await BundleCake.find({
        query: values,
      });
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const createBundleCake = createAsyncThunk(
  'bundleCake/createBundleCake',
  async (values: CreatePatchBundleCake, { rejectWithValue }) => {
    try {
      const response = await BundleCake.create(values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const patchBundleCake = createAsyncThunk(
  'bundleCake/patchBundleCake',
  async ({ id, ...values }: CreatePatchBundleCake, { rejectWithValue }) => {
    try {
      const response = await BundleCake.patch(id, values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getBundleCake = createAsyncThunk(
  'bundleCake/getBundleCake',
  async ({ id }: GetBundleCake, { rejectWithValue }) => {
    try {
      const response = await BundleCake.get(id);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);
